import { StyleSheet, View } from 'react-native';

import { Pill, Text } from '@/components/ui';
import { useTheme } from '@/theme';

export type TimelineEntry = {
  year: string;
  title: string;
  body: string;
  current?: boolean;
};

export function Timeline({ entries }: { entries: TimelineEntry[] }) {
  const theme = useTheme();
  return (
    <View style={[styles.outer, { borderLeftColor: theme.colors.rule }]}>
      {entries.map((e, i) => (
        <View key={e.year + i} style={styles.row}>
          <View
            style={[
              styles.bullet,
              {
                backgroundColor: e.current ? theme.colors.accentAlt : theme.colors.fg,
                borderColor: theme.colors.bg,
              },
            ]}
          />
          <View style={styles.content}>
            <View style={styles.headRow}>
              <Text
                style={{
                  fontFamily: theme.fontFamily.displayItalic,
                  fontStyle: 'italic',
                  fontSize: 56,
                  lineHeight: 56,
                  color: e.current ? theme.colors.accentAlt : theme.colors.fg,
                }}
              >
                {e.year}
              </Text>
              {e.current ? <Pill variant="ember">Jetzt</Pill> : null}
            </View>
            <Text variant="h3" style={{ marginTop: 12 }}>
              {e.title}
            </Text>
            <Text variant="body" tone="fgSoft" style={{ marginTop: 8, maxWidth: 640 }}>
              {e.body}
            </Text>
          </View>
        </View>
      ))}
    </View>
  );
}

const styles = StyleSheet.create({
  outer: {
    paddingLeft: 24,
    borderLeftWidth: 1,
    gap: 48,
  },
  row: {
    flexDirection: 'row',
    gap: 16,
    position: 'relative',
  },
  bullet: {
    width: 16,
    height: 16,
    borderRadius: 8,
    marginTop: 12,
    marginLeft: -32,
    borderWidth: 4,
  },
  content: {
    flex: 1,
  },
  headRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 16,
    flexWrap: 'wrap',
  },
});
